import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface AirEmissionRow {
  plantName: string;
  dust:      number | null;
  nox:       number | null;
  so2:       number | null;
  monthName: string;
}

export interface SensorIssueItem {
  name:  string;
  count: number;
}

export interface AirEmissionModalData {
  aiText:              string;
  tableRows:           AirEmissionRow[];
  daysSinceExceedance: number;
  sensorIssues:        SensorIssueItem[];
  recycledWastePct:    number;
  environmentStatus:   string;
}

@Injectable({ providedIn: "root" })
export class AirEmissionModalService {
  isOpen$    = new BehaviorSubject<boolean>(false);
  modalData$ = new BehaviorSubject<AirEmissionModalData | null>(null);

  setData(data: AirEmissionModalData): void {
    this.modalData$.next(data);
  }

  open(): void {
    this.isOpen$.next(true);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) ionContent.style.setProperty("--overflow", "hidden");
  }

  close(): void {
    this.isOpen$.next(false);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) ionContent.style.removeProperty("--overflow");
  }
}
